import { render, staticRenderFns } from "./HomeViewTaskCenter.vue?vue&type=template&id=fd60869e&"
import script from "./HomeViewTaskCenter.vue?vue&type=script&lang=js&"
export * from "./HomeViewTaskCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports